module.exports = __webpack_public_path__ + "img/YouthStatistic.1dca4cff.png";